import React, { useEffect, useState } from 'react';
import './sec-booking.css'
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import Header2 from '../component/common/title';
import AddCTA from '../component/common/addcta';
import pic25 from '../assets/pic25.png'
import pic26 from '../assets/pic26.png'
import pic28 from '../assets/pic28.png'
import pic30 from '../assets/pic30.png'
import pic31 from '../assets/pic31.png'
import pic32 from '../assets/pic32.png'
import { supabase } from '../supabase';
import Input from '../component/common/input';
import pic34 from '../assets/pic34.png'
import pic35 from '../assets/pic35.png'
import pic27 from '../assets/pic27.png'
import './sec-support.css'
import './sec-feedback.css'
import pic38 from '../assets/pic38.png'
import pic39 from '../assets/pic39.png'
import pic40 from '../assets/pic40.png'



const Feedbackmanagement = () => {


const [Users, setUsers] = useState([]);
const [showForm, setShowForm] = useState(false);
const [search, setSearch] = useState('');
const [filter, setFilter] = useState('');
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [selectedDeleteId, setSelectedDeleteId] = useState(null);
const [isEditing, setIsEditing] = useState(false);
const [editingId, setEditingId] = useState(null);
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const [sort, setSort] = useState('');
const [Feeback, setFeeback] = useState([]);
const [Events, setEvents] = useState([]);

const [formData, setFormData] = useState({
  user_id: '',
  Event_id : '',
  comment: '',
  comment_ar: '',
  Rating: '',
  date: ''
});











useEffect(() => {
  const getFeedback = async () => {
    const { data, error } = await supabase
      .from('Feeback')
      .select(`
        *,
        Users:user_id (
          user_name,
          user_name_ar,
            user_email,
          profile
        ),
Events:Event_id (
  Event_title,
  Event_title_ar
)
      `);

    if (error) {
        console.log("INSERT ERROR:", error.message);
          alert(error.message);
      return;
    }

    setFeeback(data || []);
  };

  const getUsers = async () => {
    const { data } = await supabase
      .from('Users')
      .select('id, user_name, user_email');

    setUsers(data || []);
  };

  getFeedback();
  getUsers();



const getEvents = async () => {
  const { data } = await supabase
    .from('Events')
    .select('id, Event_title');

  setEvents(data || []);
};

getEvents();




}, []);











const filteredfeedback = Feeback
  .filter((item) => {
    const matchesSearch =
      (item.comment?.toLowerCase() || '').includes(search.toLowerCase()) ||
      (item.Users?.user_name?.toLowerCase() || '').includes(search.toLowerCase()) ||
      (item.Events?.Event_title?.toLowerCase() || '').includes(search.toLowerCase());

    let matchesFilter = true;

    if (filter === 'high') {
      matchesFilter = item.Rating >= 4;
    } else if (filter === 'low') {
      matchesFilter = item.Rating < 4;
    }

    return matchesSearch && matchesFilter;
  })


  .sort((a, b) => {
    if (!sort) return 0;

    const dateA = new Date(a.date);
      const dateB = new Date(b.date);
    if (sort === 'newest') {
      return dateB - dateA; 
    }

    if (sort === 'oldest') {
      return dateA - dateB; 
    }

    return 0;
  });  
    





const handleClose = () => {
  setShowForm(false);
  setIsEditing(false);
  setEditingId(null);

  setFormData({
  user_id: '',
  Event_id : '',
  comment: '',
  comment_ar: '',
  Rating: '',
  date: ''
  });
};

const createFeedback = async () => {
  const { data, error } = await supabase
    .from('Feeback')
    .insert([formData])
    .select(`
      *,
      Users:user_id (user_name, user_name_ar,   user_email,   profile),
      Events:Event_id  (Event_title, Event_title_ar)
    `);

  if (error) {
    console.log(error);
    return;
  }

  setFeeback(prev => [...prev, ...data]);
  handleClose();
};









const confirmDelete = async () => {
//   const id = selectedDeleteId;
await supabase.from('Feeback').delete().eq('id', selectedDeleteId);
  setFeeback(prev => prev.filter(m => m.id !== selectedDeleteId));

  setShowDeleteModal(false);
  setSelectedDeleteId(null);
};






const handleEditClick = (item) => {
  setFormData({
    user_id: item.user_id,
    Event_id: item.Event_id,
    comment: item.comment,
    comment_ar: item.comment_ar,
    Rating: item.Rating,
    date: item.date
  });

  setEditingId(item.id);
  setIsEditing(true);
  setShowForm(true);
};



const updateFeedback = async () => {
  const { data, error } = await supabase
    .from('Feeback')
    .update(formData)
    .eq('id', editingId)
    .select(`
      *,
      Users:user_id (user_name, user_name_ar,   user_email,  profile),
      Events:Event_id  (Event_title, Event_title_ar)
    `);

  if (error) {
    console.log(error);
    return;
  }

  setFeeback(prev =>
    prev.map(m => (m.id === editingId ? data[0] : m))
  );

  handleClose();
};





const totalFeedback = Feeback.length;

const averageRating =
  totalFeedback > 0
    ? (Feeback.reduce((sum, item) => sum + Number(item.Rating || 0), 0) / totalFeedback).toFixed(1)
    : 0;

const fiveStarCount = Feeback.filter(item => Number(item.Rating) === 5).length;


    return ( 

 <section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>

                    <section className='information-container'>
                        <article className='header-cont-event'>
                           <Header2 
                            title="Feedback & Reviews"  
                            para="View and manage customer feedback and ratings"
                            />
                          <AddCTA    title='Add Feedback'   onClick={() => setShowForm(true)} />
                        
                        </article>



{showForm && (
  <div className="overlay-create">
    <div className="container-create">

      <div className="header-create">
            <h1 className="title-create">
            {isEditing ? 'Edit Feedback' : 'Add New Feedback'}
            </h1>

        <button
          className="close-btn-create"
          onClick={handleClose}
          type="button"
        >
          <img src={pic34} alt='close' />
        </button>
      </div>




      <form className="form-create"  onSubmit={(e) => {
            e.preventDefault();
            isEditing ? updateFeedback() : createFeedback();
            }}>






                              <fieldset className="fieldset">
                                <label className='title-input'>User</label>

                                <div className="select-wrapper2">
                                  <img src={pic28} className="arrow-icon2" alt="arrow" />

                                  <select
                                    className="input-search2 select-style2"
                                    value={formData.user_id}
                                    onChange={(e) =>
                                      setFormData({ ...formData, user_id: e.target.value })
                                    }
                                  >
                                    <option value="">Select User</option>

                                    {Users.map((user) => (
                                      <option key={user.id} value={user.id}>
                                        {user.user_name} ({user.user_email})
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </fieldset>

                                <fieldset className="field-group-create">
                                <Input
                                  title="Rating (1 - 5)"
                                    type="number"  
                                  placeholder="Enter Number"
                                  min="1"
                                  max="5"
                                  value={formData.Rating}
                                  onChange={(e) =>
                                    setFormData({ ...formData, Rating: e.target.value })
                                  }
                                />
                              </fieldset>


                          <fieldset className='container-text-area'>
                               <h2 className='title-text-area'>Message</h2>
                              <textarea
                                className="main-text-area"
                                placeholder="Enter feedback"
                                value={formData.comment}
                                onChange={(e) =>
                                  setFormData({ ...formData, comment: e.target.value })
                                }
                              />
                          </fieldset>



                          <fieldset className='container-text-area'>
                               <h2 className='title-text-area'>Message (Arabic)</h2>
                                <textarea
                                className="main-text-area"
                                placeholder="Enter Arabic feedback"
                                value={formData.comment_ar}
                                onChange={(e) =>
                                  setFormData({ ...formData, comment_ar: e.target.value })
                                }
                              />
                        </fieldset>


                            <fieldset className="field-group-create">
                                <Input
                                title="Date"
                                type="date"
                                value={formData.date}
                                onChange={(e) =>
                                    setFormData({ ...formData, date: e.target.value })
                                }
                                />
                            </fieldset>
                                        <fieldset className="fieldset">
                                          <label className='title-input'>Events</label>
                                           <div className="select-wrapper2">
                                        
                                           <img src={pic28} className="arrow-icon2" alt="arrow" />
                                  <select
                                  className='input-search2 select-style2'
                                  value={formData.Event_id}
                                  onChange={(e) =>
                                    setFormData({ ...formData, Event_id: e.target.value })
                                  }
                                >
                                  <option value="">Select Event</option>
                                  {Events.map((event) => (
                                    <option key={event.id} value={event.id}>
                                      {event.Event_title}
                                    </option>
                                  ))}
                                </select>
                                 </div>
                                </fieldset>
                            
                                                        <nav className='container-ctas-craete'>
                                                                                    <button   type="button" className="cta-cancel-create" onClick={handleClose}>
                                                                                        <h2 className="cta-cancel-text-create">
                                                                                            Cancel
                                                                                        </h2>
                                                                                    </button>
                                                    
                                                                                    <button type="submit" className='cta-create'>
                                                                                    <h2 className='cta-create-text'>
                                                                                        {isEditing ? 'Edit Feedback' : 'Add New Feedback'}
                                                                                    </h2>
                                                                                    </button>
                                                        </nav>
                                

      </form>
    </div>
  </div>
)}






{showDeleteModal && (
  <section className="delete-modal-overlay">
    <article className="delete-modal" role="dialog" aria-modal="true">
      
      <header className="delete-modal-header">
        <div className="delete-icon-wrapper">
          <img src={pic35} alt='icon'></img>
        </div>

        <div className="delete-text-container">
          <h2 className="delete-title">Delete Feedback</h2>
          <p className="delete-description">
             Are you sure you want to delete this Feedback? This action cannot be undone.
          </p>
        </div>
      </header>

      <nav className="delete-modal-actions">
        <button
          className="delete-btn-cancel"
          onClick={() => {
            setShowDeleteModal(false);
            setSelectedDeleteId(null);
          }}
        >
          Cancel
        </button>

        <button
          className="delete-btn-confirm"
          onClick={confirmDelete}
        >
          Delete
        </button>
      </nav>

    </article>
  </section>
)}



<section className='container-table-plus-top-sec-feedback'>

                    <section className='container-table-feedback '>
                        <article className='card-feedbackk'>
                                <img src={pic38} alt='icon'></img>
                                <h1 className='arverage-num-feedback'>{averageRating}</h1>
                                <h3 className='sentence-feedback'>Average Rating</h3>
                        </article>
                        <article className='card-feedbackk'>
                                <img src={pic39} alt='icon'></img>
                                <h1 className='arverage-num-feedback2'>{fiveStarCount}</h1>
                                <h3 className='sentence-feedback'>5-Star Reviews</h3>
                        </article>
                         <article className='card-feedbackk'>
                                <img src={pic40} alt='icon'></img>
                                <h1 className='arverage-num-feedback3'>{totalFeedback}</h1>
                                <h3 className='sentence-feedback'>Total Feedbacks</h3>
                        </article>                       
                    </section>







                        <section className='container-table-eventp'>
                            <fieldset className="input-wrapper">
                                <input 
                                  className='input-search'
                                    placeholder="Search for user..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)} />
                                <img src={pic25} className="search-icon" alt="search" />
                            </fieldset>
                            <fieldset className='container-inputs-event-p'>
                                  <div className="select-wrapper">
                                    <img src={pic28} className="arrow-icon" alt="arrow" />
                                    <img src={pic26} className="select-icon" alt="filter" />
                                <select
                                className="input-search select-style"
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                >
                                      <option value="">Filter by</option>

                                    <option value="high">High Rating</option>
                                    <option value="low">Low Rating</option>
                                </select>
                                </div>


                                <div className="select-wrapper">
                                       <img src={pic28} className="arrow-icon" alt="arrow" />
                                    <img src={pic27} className="select-icon" alt="sort" />
                                    <select
                                    className="input-search select-style"
                                    value={sort}
                                    onChange={(e) => setSort(e.target.value)}
                                    >
                                    <option value="">Sort by</option>
                                     <option value="newest">Sort by date (Nearly upcoming)</option>
                                    <option value="oldest">Sort by date (Long-term)</option>
                                    </select>
                                </div>


                            </fieldset>



                                                               <div className="table-container" >
                                                                             <table className='table'>
                                                                                 <thead>
                                                                                 <tr className='table-header'>
                                                                                     <th className='table-header-text'></th>
                                                                                     <th className='table-header-text'>ID</th>
                                                                                     <th className='table-header-text'>User</th>
                                                                                     <th className='table-header-text'>Feedback</th>
                                                                                     <th className='table-header-text'>Rate</th>
                                                                                     <th className='table-header-text'>Event</th>
                                                                                     <th className='table-header-text'>date</th>
                                                                                     <th className='table-header-text'>User_ar</th>
                                                                                      <th className='table-header-text'>Feedback_ar</th>
                                                                                      <th className='table-header-text'>Event_ar</th>                                                                              
                                                                                     <th className='table-header-text'>Actions</th>
                                                                                 </tr>
                                                                                 </thead>
                                             
{filteredfeedback.map((item) => { return <tbody key={item.id}>
                                                                                         <tr className='table2-header'>
                                                                                             <td className='checkbox-cont-table'>
                                                                                                 <label className="custom-checkbox">
                                                                                                 <input type="checkbox" />
                                                                                                 <span className="checkmark"></span>
                                                                                                 </label>
                                                                                             </td>
                                                                                             <td className='mainwhite-table-font'>{item.id}</td>
                                                                                              <td className='container-event-row-feedback'>
                                                                                                 <img className='img-tabel-event2' src=  {item.Users?.profile} alt='pic'></img>
                                                                                                 <div className='container-event2'>
                                                                                                     <h2 className='event-title'>  {item.Users?.user_name}</h2>
                                                                                                       <p className='artistname'>
                                                                                                        {item.Users?.user_email}
                                                                                                      </p>
                                                                                                 </div>
                                                                                             </td>                                               
                                                                                       <td className='container-event-desc'> 
                                                                                         <p className='truncate-text'>{item.comment}</p>
                                                                                         </td>                                               
                                             
                                                                                             <td className='mainwhite-table-font'>  {item.Rating}</td>
                                             
                                                                                             <td className='mainwhite-table-font_ar'>  {item.Events?.Event_title}</td>
                                                                                             <td className='mainwhite-table-font_ar'>  {item.date}</td>
                                                                                                 <td className='mainwhite-table-font_ar'>  {item.Users?.user_name_ar}</td>

                                                                                                    <td className='container-event-desc'>                                                                                
                                                                                                    <p className='mainwhite-table-font_ar-TRUNC'>{item.comment_ar}</p>  
                                                                                                     </td>                                      
                                                                                             <td className='mainwhite-table-font_ar'>  {item.Events?.Event_title_ar}</td>     

                                                                                             <td className='mainwhite-table-font'>
                                                                                                 <nav className='cta-table'>
                                                                                                         <button className='cta2-table'>
                                                                                                             <img src={pic30} alt='hide'></img>
                                                                                                         </button>
                                                                                                         <button
                                                                                                         className='cta2-table'
                                                                                                         onClick={() => handleEditClick(item)}
                                                                                                         >
                                                                                                         <img src={pic31} alt='edit' />
                                                                                                         </button>
                                                                                                         <button
                                                                                                         className='cta2-table'
                                                                                                         onClick={() => {
                                                                                                             setSelectedDeleteId(item.id);
                                                                                                             setShowDeleteModal(true);
                                                                                                         }}
                                                                                                         >
                                                                                                         <img src={pic32} alt='delete' />
                                                                                                         </button>
                                                                                                         
                                                                                                 </nav>
                                                                                             </td>
                                             
                                             
                                             
                                             
                                                                                         </tr>
                                                                                 </tbody>
                                                            })}
                                                                             </table>
                                                                             </div>

                                       




                        </section>







                    </section>

            </section>
          </section>
        </section>
     );
}
 
export default Feedbackmanagement;